import React from 'react'
import ReactDOM from 'react-dom/client'
import './lib/gsap'
import App from './App.tsx'
import { preloadPricingConfig } from './lib/pricing-config'
import './styles/globals.css'
import './styles/scrollbar.css'

// VOY-512 (D1): warm the pricing-config cache ('all' + 'flight') before the first card
// renders. The 25% flash this prevents is specifically the warm-'all' / cold-'flight' window:
// after browsing hotels warms the 'all' cache (25%), a flight card's getCachedConfigSync('flight')
// falls back to that 'all' entry until the 'flight' fetch lands. (On a fully cold cache the
// fallback is DEFAULT_CONFIG = 0%, which is already flight-safe.) Preloading 'flight' closes
// that window. Fire-and-forget; preloadPricingConfig swallows its own errors.
// getCachedConfigSync('hotel') falls back to the warm 'all' cache, so hotels are covered too
// without preloading a 'hotel' row that does not exist.
void preloadPricingConfig()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)